import type { CompanyEdge } from "../../../api/client.ts";
import CompanyRelationsGraph from "../../../components/companies/CompanyRelationsGraph.tsx";
import Panel from "../../../components/Panel.tsx";

interface CompanyRelationsCardProps {
  edges: CompanyEdge[];
  companyName: string;
  companyId: string;
}

export default function CompanyRelationsCard({
  edges,
  companyName,
  companyId,
}: CompanyRelationsCardProps) {
  if (edges.length === 0) return null;
  return (
    <Panel title="Company relations" count={edges.length} sx={{ mb: 3 }}>
      <CompanyRelationsGraph edges={edges} companyName={companyName} companyId={companyId} />
    </Panel>
  );
}
